import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from '@atlas/ui';

const SocialLink = ({ socialLink: { key, link, text } }) => (
  <a aria-label={text} className="social-link" href={link} rel="noreferrer" target="_blank">
    <Icon alt={text} className="social-link__img" name={key} />
  </a>
);

SocialLink.propTypes = {
  socialLink: PropTypes.shape({
    key: PropTypes.string,
    link: PropTypes.string,
    text: PropTypes.string,
  }),
};

export default SocialLink;
